import { OptimizelyProvider } from "@optimizely/react-sdk";
import { memo } from "react";
import { useUserQuery } from "../monitor/User.state";
import { useRollbar } from "@rollbar/react";
import { optimizelyClient } from "../lib/optimizely";

const AppUserContainer = ({ children }) => {
  const user = useUserQuery()
  const rollbar = useRollbar()
  const hasUserId = user && user?.id

  let userConfig = {}
  if (hasUserId) {
      userConfig = {
          id: String(user?.id),
          attributes: {
              user_id: user?.id,
              email: user?.email,
              super: user?.super_admin,
          }
      }
  } else {
      userConfig = {
          id: localStorage.getItem('ss-anonymous-id') || (function() {
              const newId = `anon-${Math.random().toString(36).substring(2, 15)}`;
              localStorage.setItem('ss-anonymous-id', newId);
              return newId;
          })()
      }
  }

  rollbar.configure({
      payload: {
          person: {
              id: String(user?.id),
              username: user?.email,
              email: user?.email,
              super: user?.super_admin,
          }
      }
  })

  return (
      <OptimizelyProvider
          optimizely={optimizelyClient}
          isServerSide={false}
          user={userConfig}
      >
          {children}
      </OptimizelyProvider>
  )
}

export default memo(AppUserContainer)